import React from 'react';
import { faThumbsUp } from '@fortawesome/pro-solid-svg-icons/faThumbsUp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function ThumbsUpSolidIcon(
  props: React.PropsWithChildren<React.HTMLAttributes<SVGElement>>
) {
  return <FontAwesomeIcon icon={faThumbsUp} {...props} />;
}
